import { UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';

export enum QueryKey {
	ApprovalRequests = 'approval-requests',
	Awards = 'awards',
	Bonus = 'bonus',
	BonusFeedMeta = 'bonus-feed-meta',
	BonusesInfinite = 'bonuses-infinite',
	Hashtags = 'hashtags',
	Leaderboard = 'leaderboard',
	UserProfile = 'recognition-user',
}

export type MutationOptions<T = unknown, U = unknown> = Omit<UseMutationOptions<U, unknown, T>, 'mutationFn'>;

export type QueryOptions<T = unknown> = Omit<UseQueryOptions<T, unknown, T>, 'queryFn' | 'queryKey'>;

export enum ResourcePath {
	Bonus = 'bonuses/{id}',
	Bonuses = 'bonuses',
	BonusImages = 'bonus_images',
	BonusReports = 'bonus_reports',
	BonuslyUser = 'user',
	Company = 'companies/show',
	GIFs = 'gifs',
	Hashtags = 'hashtags',
	JWT = 'jwt',
	Reaction = 'reactions/{id}',
	Reactions = 'reactions',
	Recipients = 'recipients',
	Rewards = 'rewards',
	Users = 'users',
	UsersAutocomplete = 'users/autocomplete',
	Leaderboard = 'leaderboards',
	User = 'users/show',
	UsersInvite = 'invitations',
}
